export default __webpack_public_path__ + "static/media/header_edge_gray.e39965a6.png";